export const picsUrls: string[] = [
	'/UserPics/user-pic-1.svg',
	'/UserPics/user-pic-2.svg',
	'/UserPics/user-pic-3.svg',
	'/UserPics/user-pic-4.svg',
	'/UserPics/user-pic-5.svg',
	'/UserPics/user-pic-6.svg',
	'/UserPics/user-pic-7.svg',
	'/UserPics/user-pic-8.svg',
];

export const countOfUserPics = picsUrls.length;

export const randomizeUserPic = () =>
	picsUrls[Math.floor(Math.random() * picsUrls.length)];
